import { render, staticRenderFns } from "./SingleSchoolIndexView.vue?vue&type=template&id=7297c7ba"
import script from "./SingleSchoolIndexView.vue?vue&type=script&lang=js"
export * from "./SingleSchoolIndexView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports